/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultNavbar from "components/DefaultNavbar";

// Author page sections
import Profile from "pages/AboutUs/sections/Profile";
import Contact from "pages/AboutUs/sections/Contact";
import CenteredFooter from "components/Footers/CenteredFooter";

// Routes
import { routes } from "routes";
import { useTranslation } from "react-i18next";

//SEO
import SEO from "components/SEO";

// Images
import bgImage from "assets/images/beach/beach1.jpg";
import profilePicture from "assets/images/profile/owners.c1.avif";

function AboutUs() {
  const { t } = useTranslation();
  const translatedRoutes = routes(t);
  const imageUrl = window.location.origin + profilePicture;
  return (
    <>
      <SEO
        title={t("About Us") + " | Four Roses"}
        description={t(
          "Learn more about Four Roses, our rental property, amenities, and how to contact us."
        )}
        image={imageUrl}
        type="website"
        structuredData={{
          "@type": "WebPage",
          name: t("About Us") + " | Four Roses",
          description: t(
            "Learn more about Four Roses, our rental property, amenities, and how to contact us."
          ),
        }}
      />

      <DefaultNavbar
        routes={translatedRoutes}
        action={{
          type: "internal",
          route: "/book",
          label: t("book"),
          color: "info",
        }}
        transparent
        light
      />
      <MKBox bgColor="white">
        <MKBox
          minHeight="35rem"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Profile />
        </Card>
        <Contact />
        <CenteredFooter />
      </MKBox>
    </>
  );
}

export default AboutUs;
